const API_URL = process.env.REACT_APP_API_URL || "https://maraton.klubmalydunaj.sk/api";

export default API_URL;
